import { Api } from 'utils';

class HomeService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/home', params)
	}

	static doctor = {
		get: async (params?: any) => Api.createResponse('doctor/home', params)
	}

	static clinic = {
		get: async (params?: any) => Api.createResponse('clinic/home', params),
		renew: async (params?: any) => Api.createResponse('clinic/home/renew', params)
	}

	static business = {
		get: async (params?: any) => Api.createResponse('clinic/home', params),
		renew: async (params?: any) => Api.createResponse('clinic/home/renew', params)
	}

	static affiliate = {
		getPlan: async (params?: any) => Api.createResponse('app/affiliate/plan/get', params),
		getPayments: async (params?: any) => Api.createResponse('app/affiliate/get-payments', params),
		getAdvertisements: async (params?: any) => Api.createResponse('app/affiliate/advertisements/get', params),
		getVideoRoomAccess: async (params?: any) => Api.createResponse('app/affiliate/advertisements/video-room-access', params),
		getContactRequests: async (params?: any) => Api.createResponse('app/affiliate/advertisements/contacts', params),
		givePatientAccess: async (params?: any) => Api.createResponse('app/affiliate/advertisements/give-access', params),
		setContactStatus: async (params?: any) => Api.createResponse('app/affiliate/advertisements/contacts/status', params),
		getBanners: async (params?: any) => Api.createResponse('app/affiliate/get-banners', params),
		getSelects: async (params?: any) => Api.createResponse('app/affiliate/get-selects', params),
		getClassifiedRates: async (params?: any) => Api.createResponse('app/affiliate/get-classified-rates', params),
		getTeleconsultations: async (params?: any) => Api.createResponse('app/affiliate/get-my-consultations', params),
		setTeleconsultationStatus: async (params?: any) => Api.createResponse('app/affiliate/set-status', params),
		getProfile: async (params?: any) => Api.createResponse('app/affiliate/get', params),
	}

}

export default HomeService;